export default {
  superUserGnipArchiveDisconnections(state) {
    return state.superUserGnipArchiveDisconnections;
  },
  superUserCollectActiveWorkspaces(state) {
    return state.superUserCollectActiveWorkspaces;
  },
  superUserCollectActiveWorkspacesForSelect(state) {
    return state.superUserCollectActiveWorkspaces.map((type) => ({
      id: type.value,
      text:type.value +'-'+ type.name,
    }));
  },
};
